import { Form } from "antd";
import { ButtonUi, CloseBtn, FormUi, Modal } from "../../ui";
import { messageError, messageSuccess } from "../../../helpers";
import { ImportarDatosForm } from "./ImportarDatosForm";
import { TipoButtonConstants } from "../../../types/typesConstants";
import { importar_productos_by_excel } from "../../../actions";
import { useEffect, useRef, useState } from "react";

const initialValues = {
  fileExcel: null,
  errors: [],
};
const useResetFormOnCloseModal = ({ form, open }) => {
  const prevOpenRef = useRef();

  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) form.resetFields();
  }, [form, prevOpen, open]);
};
export const ImportarDatosModal = ({ open, handleClose }) => {
  const [form] = Form.useForm();
  const [loadingMigrate, setLoadingMigrate] = useState(false);
  const [errors, setErrors] = useState([]);
  const [importedSummary, setImportedSummary] = useState(null);
  useResetFormOnCloseModal({
    form,
    open,
  });
  const handleCloseModal = () => {
    setErrors([]);
    setImportedSummary(null);
    handleClose();
  };
  const handleProcesarExcel = async (values) => {
    setLoadingMigrate(true);
    try {
      const fileExcel = values?.fileExcel[0]?.originFileObj;
      const fmData = new FormData();
      fmData.append("file", fileExcel);
      const res = await importar_productos_by_excel(fmData);
      messageSuccess(res?.data?.msg);
      setImportedSummary(res?.data?.imported_summary);
      setErrors([]);
    } catch (error) {
      messageError(error?.response?.data?.msg);
      setErrors(JSON.parse(error?.response?.data?.errors));
      setImportedSummary(null);
    } finally {
      setLoadingMigrate(false);
    }
  };
  return (
    <Modal
      title="Migrar datos de productos"
      centered
      maskClosable={false}
      destroyOnHidden
      open={open}
      onCancel={handleCloseModal}
      footer={[
        <ButtonUi
          key="iniciar"
          typeUi={TipoButtonConstants.Iniciar}
          text="Iniciar migración"
          htmlType="submit"
          form="FormMigrateProductos"
          loading={loadingMigrate}
        />,
        <CloseBtn key="back" icon onClick={handleCloseModal} />,
      ]}
      width={{
        xs: "90%",
        sm: "80%",
        md: "70%",
        lg: "60%",
        xl: "50%",
        xxl: "40%",
      }}
      forceRender
    >
      <FormUi
        form={form}
        name="FormMigrateProductos"
        layout="vertical"
        autoComplete="off"
        handleSubmit={handleProcesarExcel}
        initialValues={initialValues}
      >
        <ImportarDatosForm importedsummary={importedSummary} errors={errors} />
      </FormUi>
    </Modal>
  );
};
